export const CSV_FILE = '.csv';
export const XLSX_FILE = '.xlsx';

export function generateFileName(
  featureName: string,
  extension = XLSX_FILE
): string {
  const date = new Date();
  const month = date.getMonth() + 1;
  let monthStr = month.toString();
  if (month < 10) monthStr = '0'.concat(month.toString());
  const dateToAppend = date.getDate() + monthStr + date.getFullYear();
  return `${featureName}_${dateToAppend}${extension}`;
}
